<!--
    @Author : Luo
    @Time   : 2020/12/2 12:05
-->
<template>
  <div v-if="data && data.id">
    <div class="inquire_group_question_header inquire_group_question_header_theme">
      <div class="inquire_group_question_header_title inquire_group_question_header_title_theme">
        <span><strong>{{ sub ? '-- ' : data.newSort + '、' }}</strong></span>
        <span>[<strong style="font-size: 14px">{{ getQuesTypeName(data.type) }}</strong>] </span>
        <span><strong>{{ data.content }}</strong></span>
      </div>
      <div class="inquire_group_question_header_total">
        <span style="font-size: 14px">合计：</span>
        <span>{{ optionData[data.id] ? optionData[data.id]['totalQues'] : 0 }}</span>
      </div>
    </div>
    <div class="inquire_group_question_option">
      <div class="inquire_group_question_option_con inquire_group_question_option_theme" v-for="o in data.option" :key="'group-' + group.id + '-question-' + data.id + '-option-' + o.id">
        <div class="inquire_group_question_option_content"><span>{{ o.content }}</span></div>
        <div class="inquire_group_question_option_total inquire_group_question_option_total_theme">
          <div class="inquire_group_question_option_total_process">
            <i :style="{ width: getOptionRatio(data.id, o.sort) }"></i>
            <span>{{ getOptionRatio(data.id, o.sort) }}</span>
          </div>
            <div class="inquire_group_question_option_total_text">
              <span>{{ getOptionTotal(data.id, o.sort) }}</span>
            </div>
        </div>
      </div>
      <!-- 城市无选项，需要把所有已选城市列出 -->
      <template v-if="isSingleCity(data.content)">
        <div class="inquire_group_question_option_con inquire_group_question_option_theme" v-for="o in cityCompletedData" :key="'group-' + group.id + '-question-' + data.id + '-option-city-' + o">
          <div class="inquire_group_question_option_content"><span>{{ getCityVal(o) }}</span></div>
          <div class="inquire_group_question_option_total inquire_group_question_option_total_theme">
            <div class="inquire_group_question_option_total_process">
              <i :style="{ width: getOptionRatio(data.id, o) }"></i>
              <span>{{ getOptionRatio(data.id, o) }}</span>
            </div>
            <div class="inquire_group_question_option_total_text">
              <span>{{ getOptionTotal(data.id, o) }}</span>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { resetSpecNum } from '@/components/common/common_js'

export default {
  name: 'modal-inquire-ques',
  props: {
    group: {
      type: Object
    },
    data: {
      type: Object
    },
    optionData: {
      type: Object
    },
    cityCompletedData: {
      type: Array
    },
    cityData: {
      type: Object
    },
    sub: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // 获取问题类型
    getQuesTypeName: function (val) {
      let tempVal = ''

      switch (val) {
        case 'multiple':
          tempVal = '多选'
          break
        case 'single':
          tempVal = '单选'
          break
        case 'fill-in':
          tempVal = '填空'
          break
        case 'multiple-fill-in':
          tempVal = '多选-填空'
          break
        case 'single-city':
          tempVal = '单选-城市'
          break
        default:
          tempVal = '错误'
          break
      }

      return tempVal
    },
    // 获取选项比例
    getOptionRatio: function (id, key) {
      const that = this

      const tempRatio = that.optionData[id] ? that.optionData[id][key] / that.optionData[id]['totalQues'] : 0

      return tempRatio ? resetSpecNum(tempRatio).toFixed(0) + '%' : 0
    },
    // 获取选项统计数据
    getOptionTotal: function (id, key) {
      const that = this

      const tempRatio = that.optionData[id] ? that.optionData[id][key] : 0

      return tempRatio || 0
    },
    isSingleCity: function (v) { return v.indexOf('城市') > -1 },
    // 根据code获取城市名称
    getCityVal: function (v) {
      const that = this
      let tempVal = v

      if (v) {
        tempVal = that.cityData[v] ? that.cityData[v] : v
      }

      return tempVal
    }
  }
}
</script>

<style scoped>
.inquire_group_question_header {display: flex;align-items: center}
.inquire_group_question_header_total {margin-left: 40px;display: flex;align-items: center}
.inquire_group_question_option {margin-top: 10px;padding-left: 10px}
.inquire_group_question_option_con + .inquire_group_question_option_con {margin-top: 8px}
.inquire_group_question_option_con {display: flex;align-items: center}
.inquire_group_question_option_total {margin-left: 40px}

.inquire_group_question_header_theme {font-size: 18px;justify-content: space-between}
.inquire_group_question_header_title_theme {width: 80%}
.inquire_group_question_option_theme {cursor: pointer;display: flex;align-items: center;justify-content: space-between;border-bottom: 1px solid #EEE;padding: 0 8px;height: 40px}
.inquire_group_question_option_theme:hover {background-color: rgb(76, 139, 255, .2)}
.inquire_group_question_option_total_theme {width: 20%;display: flex;align-items: center;justify-content: space-between}
.inquire_group_question_option_total_theme .inquire_group_question_option_total_process {text-align: right;position: relative;height: 16px;line-height: 16px;display: block;width: 85%;background: #e2e2e2;border-radius: 8px;font-size: 12px;color: #000}
.inquire_group_question_option_total_theme .inquire_group_question_option_total_process i {display: block;border-radius: 6px;position: absolute;left: 0;width: 0;height: 14px;top: 1px;background: rgb(73, 213, 3)}
.inquire_group_question_option_total_theme .inquire_group_question_option_total_process span {margin-right: 8px}
.inquire_group_question_option_total_theme .inquire_group_question_option_total_text span {z-index: 9;position: relative;font-size: 14px}
</style>



// WEBPACK FOOTER //
// src/components/page-inquire-question/el-ques.vue